import { SHOOB_DAY_SUFFIX, isShoobDayKey, stripShoobDaySuffix } from './shoob-day'

describe('isShoobDayKey', () => {
  it('is true for a day key tagged with the Shoob suffix', () => {
    expect(isShoobDayKey(`2026-10-03${SHOOB_DAY_SUFFIX}`)).toBe(true)
  })

  it('is false for a plain school day key', () => {
    expect(isShoobDayKey('2026-10-03')).toBe(false)
  })

  it('is false for null/undefined (no day selected yet)', () => {
    expect(isShoobDayKey(null)).toBe(false)
    expect(isShoobDayKey(undefined)).toBe(false)
  })
})

describe('stripShoobDaySuffix', () => {
  it('removes the Shoob suffix, leaving the plain date', () => {
    expect(stripShoobDaySuffix(`2026-10-03${SHOOB_DAY_SUFFIX}`)).toBe('2026-10-03')
  })

  it('is a no-op on a plain school day key', () => {
    expect(stripShoobDaySuffix('2026-10-03')).toBe('2026-10-03')
  })
})
